import React from 'react';

import { useCurrentUser } from 'Auth';

import {
  useLoadPartnerApi,
  useCreatePartnerApi,
  useUpdatePartnerApi,
} from 'scenes/ApiIntegrations/data';

import ApiIntegrationForm from './ApiIntegrationForm';
import { OWNER, NAME } from './constants';

export const ApiIntegrationFormCreate = ({
  onClose,
  onSubmit,
  onExited,
  open,
}) => {
  const [create, { isLoading: isCreating }] = useCreatePartnerApi();
  const user = useCurrentUser();
  const handleSubmit = async (values = {}) => {
    try {
      const api = await create(values);
      onSubmit(api);
    } catch (e) {}
  };

  return (
    <ApiIntegrationForm
      title={'Add Partner API'}
      loading={isCreating}
      onClose={onClose}
      initialValues={{
        [OWNER]: user.id,
      }}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
      isShowPartnerApiIntegration={true}
    />
  );
};

export const ApiIntegrationFormEdit = ({ id, onClose, onExited, open }) => {
  const { data, isLoading } = useLoadPartnerApi({ id });
  const [update, { isLoading: isUpdating }] = useUpdatePartnerApi();

  const handleSubmit = async (values) => {
    const response = await update(values);
    onClose(response);
  };

  return (
    <ApiIntegrationForm
      title={'Edit Partner API'}
      subTitle={data?.[NAME]}
      entityId={id}
      loading={isLoading || isUpdating}
      onClose={onClose}
      initialValues={data}
      active={!!data}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
      isShowPartnerApiIntegration={false}
      isEdit={true}
    />
  );
};
